import { HUDL_TRACKERS } from '../trackers/HudlTrackers';
export const SNOWPLOW_PROD_URI = 'jnl7d8fsqlfo91xd.hudl.com';
export const SNOWPLOW_THOR_URI = 'jnl7d8fsqlfo91xd.thorhudl.com';
export default class BaseTrackerFactory {
    static _trackers = {};
    createTracker(key, platform, env, userID) {
        if (!BaseTrackerFactory._trackers[key]) {
            const trackerDefinition = HUDL_TRACKERS[key];
            const appID = trackerDefinition.appID[platform];
            const namespace = trackerDefinition.namespace[platform];
            const endpoint = env === 'prod' ? SNOWPLOW_PROD_URI : SNOWPLOW_THOR_URI;
            if (!appID || !namespace) {
                throw new Error(`Tracker ${key} is not supported on ${platform}`);
            }
            BaseTrackerFactory._trackers[key] = this.newTrackerInstance(namespace, appID, env, endpoint);
        }
        void BaseTrackerFactory._trackers[key].setUserID(userID);
    }
    getTracker(key) {
        const tracker = BaseTrackerFactory._trackers[key];
        if (!tracker) {
            throw new Error(`Tracker has not been created for ${key}`);
        }
        return tracker;
    }
}

//# sourceMappingURL=BaseTrackerFactory.js.map